import { useMemo } from 'react';

import { moveToGoods } from './moveToGoods';
import { moveToLikeFolders } from './moveToLikeFolders';
import { moveToRankingGoods } from './moveToRankingGoods';
import { useMoveToRecentlyViewedGoods } from './useMoveToRecentlyViewedGoods';
import { moveToSearch } from './moveToSearch';
import { moveToToday } from './moveToToday';
import { useMoveToMarketHome } from './useMoveToMarketHome';
import { moveToWebview } from './moveToWebview/moveToWebview';

export const useNavigator = () => {
  const { moveToRecentlyViewedGoods } = useMoveToRecentlyViewedGoods();
  const { moveToMarketHome } = useMoveToMarketHome();

  const navigator = useMemo(
    () => ({
      moveToWebview,
      moveToRecentlyViewedGoods,
      moveToMarketHome,
      moveToRankingGoods,
      moveToGoods,
      moveToSearch,
      moveToToday,
      moveToLikeFolders,
    }),
    [moveToMarketHome, moveToRecentlyViewedGoods],
  );

  return { navigator };
};
